export default class CartaoCredito {
  agrupador = 0;
  numeroParcelas = '';
  numeroCartao = '';
  nomeCartao = '';
  mesVencimento = '';
  anoVencimento = '';
  cvv = '';
  bandeira = '';
  valor: number;
  cartaoVerificado: boolean;
}
